import { lazy } from "react";
import Loadable from "app/components/Loadable";

const HardDiskList = Loadable(lazy(() => import("./HardDiskList")));
const HardDiskAdd = Loadable(lazy(() => import("./HardDiskAdd")));

const HardDiskRoutes = [
  { path: "/asset/hdd", element: <HardDiskList /> },
  { path: "/asset/hdd/:mode/:id", element: <HardDiskAdd /> },
];

export default HardDiskRoutes;
